import {get, post} from "../../../utils/http";
import {api} from "../../../utils/api";

class AlibabaOrderApi {
  fxOrderPreview(order_sku_id){
    return  get(api.alibabaFxOrderPreview,{order_sku_id})
  }
  fxOrderCreate(order_sku_id){
    return  post(api.alibabaFxOrderCreate,{order_sku_id})
  }
  grouppayUrl(orderIds){
    return get(api.alibabaGrouppayUrl,{order_ids:orderIds})
  }
  list(data){
    return get(api.alibabaFxOrderList,data)
  }
  info(orderFenxiaoAlibabaId){
    return get(api.alibabaFxOrderInfo,{order_fenxiao_alibaba_id:orderFenxiaoAlibabaId})
  }
  logisticsBuyerView(orderId,logisticsId){
    return get(api.logisticsBuyerView,{order_id:orderId,logistics_id:logisticsId})

}
}



const alibabaOrderApi = new AlibabaOrderApi();
export default alibabaOrderApi;



// WEBPACK FOOTER //
// ./src/views/alibaba/order/api.js